module.exports = __webpack_public_path__ + "static/img/bg_index_time_limit.70b08ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_index_time_limit.png
// module id = 1lkw
// module chunks = 192